import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaDownload, FaArrowDown, FaEnvelope, FaLinkedin, FaGithub } from 'react-icons/fa';
import { useLanguage } from '../utils/LanguageContext';
import './Header.css';

const Header = () => {
  const [displayText, setDisplayText] = useState('');
  const { t } = useLanguage();
  const fullText = t('greeting');
  const tagline = t('tagline');

  useEffect(() => {
    let index = 0;
    setDisplayText(''); // Reset the display text when language changes
    
    const timer = setInterval(() => {
      if (index <= fullText.length) {
        setDisplayText(fullText.slice(0, index));
        index++;
      } else {
        clearInterval(timer);
      }
    }, 100);

    return () => clearInterval(timer);
  }, [fullText]); // Add fullText as dependency to re-run when language changes

  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="header-section">
      <div className="header-background">
        <div className="header-pattern"></div>
        <div className="header-overlay"></div>
      </div>
      
      <div className="container">
        <div className="header-content">
          <motion.div 
            className="profile-section"
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="profile-card">
              <div className="profile-image-wrapper">
                <img 
                  src="/api/profile/profile.png" 
                  alt="Ahmed Asakrah - Software Engineer" 
                  className="profile-image"
                />
                {/* <div className="profile-status">
                  <div className="status-dot"></div>
                  <span>Available for opportunities</span>
                </div> */}
              </div>
              
              <div className="profile-info">
                <div className="location">
                  <span>📍 Düsseldorf, Germany</span>
                </div>
                <div className="social-quick-links">
                  <a href="mailto:a7krah@gmail.com" className="social-icon" title="Email">
                    <FaEnvelope />
                  </a>
                  <a href="https://www.linkedin.com/in/aasakra/" target="_blank" rel="noopener noreferrer" className="social-icon" title="LinkedIn">
                    <FaLinkedin />
                  </a>
                  <a href="https://github.com/ahmadasakra" target="_blank" rel="noopener noreferrer" className="social-icon" title="GitHub">
                    <FaGithub />
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div 
            className="text-section"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <div className="content-card">
              <motion.div 
                className="title-section"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
              >
                <h1 className="hero-title">
                  {displayText}
                  <span className="cursor">|</span>
                </h1>
                
                <div className="tagline-container">
                  <motion.p 
                    className="hero-tagline"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 2 }}
                  >
                    {tagline}
                  </motion.p>
                  <div className="tagline-accent"></div>
                </div>
              </motion.div>
              
              <motion.p 
                className="hero-description"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 2.5 }}
              >
                {t('description')}
              </motion.p>

              <motion.div 
                className="hero-actions"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 3 }}
              >
                <button 
                  className="btn btn-primary"
                  onClick={scrollToContact}
                >
                  <FaEnvelope />
                  <span>Get in Touch</span>
                </button>
                
                <button 
                  className="btn btn-secondary" 
                  onClick={scrollToAbout}
                >
                  <span>Learn More</span>
                  <FaArrowDown />
                </button>
              </motion.div>

              <motion.div 
                className="stats-section"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 3.5 }}
              >
                <div className="stat-item">
                  <span className="stat-number">3+</span>
                  <span className="stat-label">Years Experience</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">10+</span>
                  <span className="stat-label">Projects Completed</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">5+</span>
                  <span className="stat-label">Technologies</span>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>

        <motion.div 
          className="scroll-indicator"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 4 }}
          onClick={scrollToAbout}
        >
          <div className="scroll-content">
            <FaArrowDown className="scroll-arrow" />
            <span>{t('scrollDown')}</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Header; 